/**
 * Firebase Auth listener-to-Observable bridge.
 *
 * Stateless factory: each subscription mints one `onIdTokenChanged`
 * listener. Multiple consumers should share a single subscription via
 * `shareReplay({ bufferSize: 1, refCount: true })` at the call site.
 */
import { onIdTokenChanged, type Auth, type User as FirebaseUser } from 'firebase/auth';
import { from, Observable, switchMap } from 'rxjs';

export function idTokenUser$(auth: Auth): Observable<FirebaseUser | null> {
  return from(auth.authStateReady()).pipe(
    switchMap(
      () =>
        new Observable<FirebaseUser | null>((sub) =>
          onIdTokenChanged(
            auth,
            (u) => sub.next(u),
            (err) => sub.error(err),
          ),
        ),
    ),
  );
}
